import axios, { AxiosRequestConfig } from 'axios';
import {ProductGroupsResponse,ProductInfo,AllWarehouseMetricsResponse} from "../models/NV02Lava";
import CSharpUtils from './CSharpUtils';
import Utils from './Utils';

export const fetchProductGroupsMetrics = (companyId: number,warehouse:number) => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/product/groups`,
    params: {
      CompanyId: companyId,
      warehouse: warehouse,
    },
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: "json",
    responseEncoding: "utf8",
    timeout: 10000,
  };

  return axios.request<any>(config)
    .then(response => {
      return response.data.groups;
    })
    .catch(error => {
      console.error("API Error (fetchProductGroupsMetrics): ", error);
      throw error;
    });
};
export const fetchWarehouseMetrics = (companyId: number): Promise<AllWarehouseMetricsResponse> => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/product/warehouse/metrics`,
    params: {
      CompanyId: companyId,
    },
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: "json",
    responseEncoding: "utf8",
    timeout: 10000,
  };

  return axios.request<any>(config)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error("API Error (fetchWarehouseMetrics): ", error);
      throw error;
    });
};
export const fetchProductByGroup = (companyId: number,groupe:number,warehouse:number) => {
    const config: AxiosRequestConfig = {
   method: "get",
   url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/product/stock/group`,
    params: { CompanyId: companyId,
      Group: groupe,
      warehouse: warehouse,
     },
   headers: {
       accept: 'application/json',
     Authorization: `Bearer ${CSharpUtils.Get_Token}`, 
   },
   responseType: "json",
   responseEncoding: "utf8",
   timeout: 10000,
 };

 return axios.request<any>(config)
   .then(response => {
       return response.data.items;
   })
   .catch(error => {
     console.error("API Error: ", error); 
     throw error;
   });
};
export const fetchLagerKodeByFirmId = () => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/nv03/getwarehouseName`,
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: "json",
    responseEncoding: "utf8",
    timeout: 10000,
  };

  return axios.request<any>(config);
};

